/* eslint-disable jsx-a11y/iframe-has-title */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react';
import Nav from '../components/layout/Nav';
import Footer from '../components/layout/Footer';
import '../styles/contact.scss';
import { FaFacebookF } from 'react-icons/fa';
import { FaInstagram } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';
import { FaPhoneAlt } from 'react-icons/fa';
import { MdEmail } from 'react-icons/md';
import { FaLocationDot } from 'react-icons/fa6';
import { serverUrl } from '../serverUrl';
import { toast } from 'react-toastify';

const Contact = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    phone: '',
    email: '',
    message: '',
    acceptTerms: false,
  });

  const [loading, setLoading] = useState(false);
  const [submitStatus, setSubmitStatus] = useState({
    success: false,
    error: null,
    ticketId: null,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Reset previous status
    setSubmitStatus({ success: false, error: null, ticketId: null });
    setLoading(true);

    try {
      const response = await serverUrl.post('helpdesk/contact-us-submit/', {
        first_name: formData.firstName,
        last_name: formData.lastName,
        phone: formData.phone,
        email: formData.email,
        message: formData.message,
      });

      const data = response.data;

      if (response.status === 201 || response.status === 200) {
        // Success
        setSubmitStatus({
          success: true,
          error: null,
          ticketId: data.data?.ticket_id || null,
        });

        // Reset form
        setFormData({
          firstName: '',
          lastName: '',
          phone: '',
          email: '',
          message: '',
          acceptTerms: false,
        });

        // Show success toast with ticket ID
        const ticketMessage = data.data?.ticket_id
          ? `\nTicket ID: ${data.data.ticket_id}`
          : '';

        toast.success(
          `✅ Thank you for contacting ARTIZA!\nWe have received your message and will respond within 24 hours.${ticketMessage}`,
          {
            position: 'top-right',
            autoClose: 8000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          },
        );
      } else {
        // Handle validation errors
        let errorMessage = 'Something went wrong. Please try again.';

        if (data.errors) {
          if (typeof data.errors === 'object') {
            errorMessage = Object.values(data.errors).flat().join('\n');
          } else {
            errorMessage = data.errors;
          }
        }

        setSubmitStatus({
          success: false,
          error: errorMessage,
          ticketId: null,
        });

        toast.error(`❌ ${errorMessage}`, {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      }
    } catch (error) {
      console.error('Submission error:', error);

      // Handle axios error response
      let errorMessage =
        'Network error. Please check your connection and try again.';

      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        const errorData = error.response.data;
        if (errorData.errors) {
          if (typeof errorData.errors === 'object') {
            errorMessage = Object.values(errorData.errors).flat().join('\n');
          } else {
            errorMessage = errorData.errors;
          }
        } else if (errorData.message) {
          errorMessage = errorData.message;
        } else {
          errorMessage = `Server error: ${error.response.status}`;
        }
      } else if (error.request) {
        // The request was made but no response was received
        errorMessage = 'No response from server. Please check your connection.';
      }

      setSubmitStatus({
        success: false,
        error: errorMessage,
        ticketId: null,
      });

      toast.error(`❌ ${errorMessage}`, {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Nav />

      {/* Hero Section */}
      <section className="contact-page-hero">
        <div className="contact-page-hero-content">
          <h1>Contact Us</h1>
          <h6>
            <a href="/">Home</a> - Contact us
          </h6>
        </div>
      </section>

      {/* Contact Section */}
      <section className="get-in-touch">
        <div className="contact-flex-container">
          {/* Left Column - Contact Information */}
          <div className="contact-info">
            <div className="contact-item">
              <h2 className="section-title">Get In Touch With Us</h2>
              <p className="section-subtitle">
                Have questions or need assistance? We're here to help!
              </p>
            </div>

            {/* Phone Numbers */}
            <div className="contact-item">
              <div className="info-content">
                <div className="icon-wrapper">
                  <FaPhoneAlt />
                </div>
                <div className="text-wrapper">
                  <h4>Contact Us</h4>
                  <p>
                    <a href="tel:+01234567890">+01234-567890</a>
                  </p>
                  <p>
                    <a href="tel:+012345688765">+01234-5688765</a>
                  </p>
                </div>
              </div>
            </div>

            {/* Email Address */}
            <div className="contact-item">
              <div className="info-content">
                <div className="icon-wrapper">
                  <MdEmail />
                </div>
                <div className="text-wrapper">
                  <h4>Email Address</h4>
                  <p>
                    <a href="mailto:artizakenya@gmail.com">
                      artizakenya@gmail.com
                    </a>
                  </p>
                </div>
              </div>
            </div>

            {/* Follow Us */}
            <div className="contact-item follow-us">
              <h4>Follow Us</h4>
              <div className="social-icons">
                <a
                  href="#"
                  className="social-icon"
                  aria-label="Facebook"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaFacebookF />
                </a>
                <a
                  href="#"
                  className="social-icon"
                  aria-label="Twitter"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaXTwitter />
                </a>
                <a
                  href="#"
                  className="social-icon"
                  aria-label="Instagram"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaInstagram />
                </a>
              </div>
            </div>
          </div>

          {/* Right Column - Contact Form */}
          <form className="contact-form" onSubmit={handleSubmit} noValidate>
            {/* First Name & Last Name */}
            <div className="form-field-group">
              <div className="form-group form-group-half">
                <label htmlFor="firstName">
                  First Name <span className="required-asterisk">*</span>
                </label>
                <input
                  type="text"
                  id="firstName"
                  name="firstName"
                  placeholder="Enter your first name"
                  value={formData.firstName}
                  onChange={handleChange}
                  required
                  disabled={loading}
                  aria-required="true"
                />
              </div>

              <div className="form-group form-group-half">
                <label htmlFor="lastName">
                  Last Name <span className="required-asterisk">*</span>
                </label>
                <input
                  type="text"
                  id="lastName"
                  name="lastName"
                  placeholder="Enter your last name"
                  value={formData.lastName}
                  onChange={handleChange}
                  required
                  disabled={loading}
                  aria-required="true"
                />
              </div>
            </div>

            {/* Phone & Email */}
            <div className="form-field-group">
              <div className="form-group form-group-half">
                <label htmlFor="phone">
                  Phone Number <span className="required-asterisk">*</span>
                </label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  placeholder="e.g., +254 712 345 678"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                  disabled={loading}
                  aria-required="true"
                />
              </div>

              <div className="form-group form-group-half">
                <label htmlFor="email">
                  Email <span className="required-asterisk">*</span>
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  placeholder="Enter your email address"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  disabled={loading}
                  aria-required="true"
                />
              </div>
            </div>

            {/* Message Area */}
            <div className="form-group">
              <label htmlFor="message">
                Your Message <span className="required-asterisk">*</span>
              </label>
              <textarea
                id="message"
                name="message"
                placeholder="Please describe your inquiry in detail..."
                rows="5"
                value={formData.message}
                onChange={handleChange}
                required
                disabled={loading}
                aria-required="true"
                minLength="10"
              />
              <small className="character-count">
                {formData.message.length} characters (minimum 10)
              </small>
            </div>

            {/* Submit Button */}
            <button type="submit" className="submit-btn" disabled={loading}>
              {loading ? (
                <>
                  <span className="spinner"></span>
                  Submitting...
                </>
              ) : (
                'Submit Now'
              )}
            </button>

           

            
          </form>
        </div>
      </section>

      {/* Google Maps Iframe */}
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14438.014278827262!2d36.74962565!3d-1.39766815!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x182f05c52ffa57e1%3A0xbc9dfefe6d0aaad6!2sThe%20Siron%20Place%20Hotel!5e1!3m2!1sen!2ske!4v1761069202613!5m2!1sen!2ske"
        height="600"
        style={{ border: 0 }}
        allowFullScreen=""
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        title="ARTIZA Office Location Map"
      ></iframe>

      <Footer />
    </div>
  );
};

export default Contact;
